import {StorageStrategy} from '../interfaces/storageStrategy';
import {KEY_CLEARED} from '../../constants/keyChanges';
import {noop} from '../../helpers/noop';
import {StorageService} from '../interfaces/storageService';
import {StorageKeyManager} from '../../helpers/storageKeyManager';
import {Observable} from 'rxjs';
import {distinctUntilChanged, filter, shareReplay, switchMap} from 'rxjs/operators';

class SyncStorage implements StorageService {
	constructor(protected strategy: StorageStrategy<any>) {
	}

	retrieve(key: string): any {
		let value: any;
		this.strategy.get(StorageKeyManager.normalize(key)).subscribe((result) => value = typeof result === 'undefined' ? null : result);
		return value;
	}

	store(key: string, value: any): any {
		this.strategy.set(StorageKeyManager.normalize(key), value).subscribe(noop);
		return value;
	}

	clear(key?: string): void {
		if (key !== undefined)
			this.strategy.del(StorageKeyManager.normalize(key)).subscribe(noop);
		else this.strategy.clear().subscribe(noop);
	}

	getStrategyName(): string {return this.strategy.name; }

	observe(key: string): Observable<any> {
		key = StorageKeyManager.normalize(key);
		return this.strategy.keyChanges.pipe(
			filter((changed: string | null) => changed === KEY_CLEARED || changed === key),
			switchMap(() => this.strategy.get(key)),
			distinctUntilChanged(),
			shareReplay({refCount: true, bufferSize: 1})
		);
	}

}

export {SyncStorage};
